import $ from 'jquery';
// import mpro from './mpro.init';

import { applyComponentClickRestrictions } from '../../util/plugin.js';
import { getOptionsFromDataset } from '../../util/dataset.js';

import MpModal from '../../modules/components/modal.js';


// Export helpers to mpro namespace
mpro.showModal = MpModal.show.bind(MpModal);
mpro.getActiveModal = MpModal.getActive.bind(MpModal);
mpro.getAllModals = MpModal.getAll.bind(MpModal);
mpro.closeModal = MpModal.close.bind(MpModal);
mpro.closeAllModals = MpModal.closeAll.bind(MpModal);

// Add init function that is executed on every page/fragment render
mpro.addInitStatic(($container) => {

	// Find all drawer elements
	const $items = $container.find('[data-modal]');

	if ($items.length > 0) {

		// Drawer Clicks
		$items.on('click.mp-modal', function(e) {

			/** @type {HTMLElement} */
			const that = this;
			const options = getOptionsFromDataset(that, 'modal', true);

			// Standard component click restrictions
			if (applyComponentClickRestrictions('modal', options, e) === false) {
				return;
			}

			// Close all other modals
			// MpModal.closeAll({ dismissible: true });

			// Close dropdowns/tooltips/popovers
			mpro.closeSimpleOverlays();
			// Also remove toasts
			mpro.closeAllToasts();

			// Display the instance
			MpModal.show({
				relatedTarget: that,
				url: that.getAttribute('href'),
				skipDataset: true,
				...options,
			});
		});
	}
});

export default mpro;
